import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
Vue.use(VueFormGenerator);

import fieldS3Upload from './s3-upload.vue';
Vue.component('field-s3-upload', fieldS3Upload);

import '@/assets/vue-form-generator.scss';

export default VueFormGenerator;
